import React, { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";

// REDUX
import { initializeApp } from "../../_redux/initializeAppSlice";
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// COMPONENTS
import SearchBar from "components/Search/SearchBar";

// AWS
import { Auth } from "aws-amplify";

function Navbar() {
  const { location } = useHistory();
  const dispatch = useDispatch();

  const pathShowSearch = [
    "/loanRequest",
    "/sandbox",
    "/transferLoan",
    "/loan",
    "/giftRequest",
    "/creditBuro",
    "/leasingRequest",
    "/leasingTransferLoan",
    "/leasingLoan"
  ];

  const showSearch = pathShowSearch.includes(location.pathname);
  const searchBar = useSelector((state) => state.searchBar);
  const history = useHistory();

  useEffect(() => {
    if (!searchBar.value) return;
    dispatch(onChangeSearchBar(""));
  }, [location]);

  const logOut = async () => {
    await Auth.signOut();
    dispatch(initializeApp());
  };

  if(history.location.pathname.search("/contactBook") !== -1) {
    return null
  }


  return (
    <>
      {/* Navbar */}
      <nav
        className={classNames(
          "absolute bg-blue-500 top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center py-2 p-4",
          { "py-3": !showSearch }
        )}
      >
        <div className="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap px-3 ml-4">
          {showSearch ? (
            <div className="flex-start z-50">
              <SearchBar />
              {/* <Select /> */}
            </div>
          ) : (
            <div></div>
          )}
          <div className="text-white" onClick={logOut}>
            Logout
          </div>
        </div>
      </nav>
      {/* End Navbar */}
    </>
  );
}

export default withRouter(Navbar);
